import { AccountType } from '@/common/types'
import type { AddressDetails } from '@/common/types'

export const CONTRACT_NOTES_CLIENT_PREFERENCES = {
    PRIMARY_EMAIL: 'PRIMARY_EMAIL',
    CUSTOM_EMAIL: 'CUSTOM_EMAIL',
    DISABLED: 'DISABLED',
} as const

export type ContractNotesClientPreference =
    (typeof CONTRACT_NOTES_CLIENT_PREFERENCES)[keyof typeof CONTRACT_NOTES_CLIENT_PREFERENCES]

export type ContractNotesPreference = {
    preference: ContractNotesClientPreference
    email?: string
}

export type CommunicationPreferences = {
    contractNotes?: ContractNotesPreference
    registrationAddress?: AddressDetails
}

export type CreateAccountPayload = {
    accountName: string
    accountType: AccountType
    accountId?: string
    communicationPreferences?: CommunicationPreferences
    postalAddress?: AddressDetails
}

export type UpdateAccountSettingsPayload = {
    communicationPreferences?: CommunicationPreferences
    registrationAddress?: AddressDetails
    displayName?: string
}

export const ACCOUNT_PARTICIPANT_ROLES = {
    PRIMARY_APPLICANT: 'PRIMARY_APPLICANT',
    TRUST: 'TRUST',
    TRUSTEE: 'TRUSTEE',
    DIRECTOR: 'DIRECTOR',
    BENEFICIAL_OWNER: 'BENEFICIAL_OWNER',
    ADVISER: 'ADVISER',
    // ACCESS ACCOUNT
    PARTICIPANT: 'PARTICIPANT',
} as const

export type AccountParticipantRole = (typeof ACCOUNT_PARTICIPANT_ROLES)[keyof typeof ACCOUNT_PARTICIPANT_ROLES]

export const ACCOUNT_PARTICIPANT_ACCESS_PROFILES = {
    NONE: 'NONE',
    VIEW: 'VIEW',
    TRADE: 'TRADE',
    FULL: 'FULL',
} as const

export type AccountParticipantAccessProfile =
    (typeof ACCOUNT_PARTICIPANT_ACCESS_PROFILES)[keyof typeof ACCOUNT_PARTICIPANT_ACCESS_PROFILES]

export const ACCOUNT_PARTICIPANT_CONFIRMATION_STATUSES = {
    REQUIRED: 'REQUIRED',
    SUCCESSFUL: 'SUCCESSFUL',
    DENIED: 'DENIED',
    NOT_REQUIRED: 'NOT_REQUIRED',
} as const

export type AccountParticipantConfirmationStatus =
    (typeof ACCOUNT_PARTICIPANT_CONFIRMATION_STATUSES)[keyof typeof ACCOUNT_PARTICIPANT_CONFIRMATION_STATUSES]

export type AccountParticipantListItem = {
    userId: string
    email: string
    firstName?: string | null
    middleName?: string | null
    lastName?: string | null
    role: AccountParticipantRole
    accessProfile: AccountParticipantAccessProfile
    status: AccountParticipantConfirmationStatus
    individualKycStatus?: string
    mobile?: string | null
    address?: AddressDetails | null
    postalAddress?: AddressDetails | null
}

export type AccountParticipantListResponse = {
    accountId: string
    participants: AccountParticipantListItem[]
}

export type TradeConfirmationEmailRequest = {
    email: string
}

export type RegistrationAddressRequest = {
    address: AddressDetails
}

export type AccountSettingsApiResponse = {
    accountId: string
}
